import styled from "styled-components";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import TabBar from "../../../../../components/TabBar";
import MainBranchSettings from "./MainBranchSettings";
import BranchFestivalSettings from "./FestivalSettings";
import BranchFinancialYearSettings from "./FinancialYearSettings";
import TreasureSettings from "./TreasureSettings";
import AuditorSettings from "./AuditorSettings";
import UsersSettings from "./UsersSettings";
import BranchBankAccountSettings from "./BankAccountSettings";

const StyledBranchSettingsRightPane = styled.div`
	margin-left: 30px;
	width: 600px;
`;

function BranchSettingsRightPane(props) {

	const {branches, selectedBranch, regionsList, isAddMode, setIsAddMode, refreshBranchesCallback} = props;

    let defaultPath = '/settings/branch/';

    let defaultTabPath = 'main';
    let {subTabPath} = useParams();

    let tabs = [
        {text: 'Main system', path: 'main'},
        {text: 'Users', path: 'users'},
        {text: 'Festivals', path: 'festivals'},
        {text: 'Treasurer', path: 'treasurer'},
        {text: 'Auditor/Examiner', path: 'auditor-examiner'},
        {text: 'Bank Account', path: 'bank-accounts'},
    ];
    if (selectedBranch && selectedBranch.RecordType === 1) {
        tabs.push({text: 'Financial Year', path: 'financial-year'});
    }

	useEffect(() => {
	});

    return (
        <StyledBranchSettingsRightPane>
			<TabBar tabs={tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath} disabled={isAddMode}></TabBar>
            {(!subTabPath || subTabPath === '' || subTabPath === 'main') && 
                <MainBranchSettings branches={branches} selectedBranch={selectedBranch} regionsList={regionsList} isAddMode={isAddMode} setIsAddMode={(mode) => {setIsAddMode(mode)}} refreshBranchesCallback={refreshBranchesCallback}></MainBranchSettings>
            }
            {subTabPath === 'festivals' &&
                <BranchFestivalSettings selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback} isAddBranchMode={isAddMode} setIsAddBranchMode={(mode) => {setIsAddMode(mode)}}></BranchFestivalSettings>
            }
            {subTabPath === 'financial-year' && selectedBranch.RecordType === 1 && 
                <BranchFinancialYearSettings selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback} isAddBranchMode={isAddMode} setIsAddBranchMode={(mode) => {setIsAddMode(mode)}}></BranchFinancialYearSettings>
            }
            {subTabPath === 'treasurer' && 
                <TreasureSettings branches={branches} selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback}></TreasureSettings>
            }
            {subTabPath === 'auditor-examiner' && 
                <AuditorSettings branches={branches} selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback}></AuditorSettings>
            }
            {subTabPath === 'users' && 
                <UsersSettings branches={branches} selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback}></UsersSettings>
            }
            {subTabPath === 'bank-accounts' && 
                <BranchBankAccountSettings branches={branches} selectedBranch={selectedBranch} refreshBranchesCallback={refreshBranchesCallback}></BranchBankAccountSettings>
            }
		</StyledBranchSettingsRightPane>
    )
}

export default BranchSettingsRightPane;